/**
 * Copyright (c) Qwoach LLC 2025. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 11.04.25
 *
 */

export default {
	"ajherzog": {
		name: "Andrea Herzog",
		userId: "DlE7KkIy37Zn9479FZHEBWIrdqV2",
		programName: "genogram",
		access: "classPaid",
	},
	"smoehlenpah": {
		name: "Sam Moehlenpah",
		userId: "xHrIyb8GvPSW79N8m2vP8ymvmx62",
		programName: "genogram",
		access: "freeTrial",
	},
	"kwint": {
		name: "Keisha Wint",
		userId: "",
		programName: "genogram",
		access: "freeTrial",
	},
	"mwheeler": {
		name: "Meeshay Wheeler",
		userId: "",
		email: "mwwheele@ncat.edu",
		programName: "genogram",
		access: "freeTrial",
	},
	"drzhou": {
		name: "Dr. Jane Zhou",
		userId: "",
		email: "z.zhou1@uel.ac.uk",
		programName: "genogram",
		access: "freeTrial",
	},
	"tradohl": {
		name: "Tami Radohl",
		userId: "",
		email: "tbradohl@fhsu.edu",
		programName: "genogram",
		access: "freeTrial",
	},
	"jdavis": {
		name: "Jonathan Davis",
		userId: "",
		email: "jcdavis1@samford.edu",
		programName: "genogram",
		access: "freeTrial",
	},
	"ChelseaCrowFuentes": {
		name: "Chelsea Crow-Fuentes",
		userId: "",
		email: "",
		programName: "genogram",
		access: "freeTrial",
	},
	"cschmidt": {
		name: "Chris Schmidt",
		userId: "",
		email: "",
		programName: "genogram",
		access: "freeTrial",
	},


	//---

	"nhalliday": {//added on May 20, 2025
		name: "Natasha Halliday",
		userId: "",
		email: "natashaahalliday@gmail.com",
		programName: "genogram",
		access: "freeTrial",
	},
	"jwarren": { //added on May 22, 2025
		name: "Jeffrey Warren",
		userId: "",
		email: "Jeffrey.Warren@nccu.edu",
		programName: "genogram",
		access: "freeTrial",
	},
	"smarycolleen": { //added on May 22, 2025
		name: "Sister Mary Colleen Schwarz",
		userId: "",
		email: "smarycolleen@benethillmonastery.org",
		programName: "genogram",
		access: "freeTrial",
	},
	"aogle": { //added on Jun 4, 2025
		name: "Anna Ogle",
		userId: "",
		email: "anna.ogle@nyu.edu",
		programName: "genogram",
		access: "freeTrial",
	},

	"poden": { //added on Jun 6, 2025
		name: "Pensiri N. Oden",
		userId: "",
		email: "oden005@gannon.edu",
		programName: "genogram",
		access: "freeTrial",
	},

	"bmakhoulian": { //added on Jun 7, 2025
		name: "Beatriz Makhoulian",
		userId: "",
		email: "beatriz.makhoulian@stonybrook.edu",
		programName: "genogram",
		access: "freeTrial",
	},

	"rwagoner": { //added on Jun 17, 2025
		name: "Raymond Wagoner",
		userId: "",
		email: "RWagoner@jbu.edu",
		programName: "genogram",
		access: "freeTrial",
	},

	// "gtopham": { //added on Jun 18, 2025. see database "teachers" collection
	// 	name: "Glade Topham",
	// 	userId: "",
	// 	email: "gtopham@ksu.edu",
	// 	programName: "genogram",
	// 	access: "freeTrial",
	// },


	// "iyaymadjian": { //added on Jun 20, 2025. see database "teachers" collection
	// 	name: "Irene Yaymadjian",
	// 	userId: "",
	// 	email: ""irene.yaymadjian@pepperdine.edu"",
	// 	programName: "genogram",
	// 	access: "freeTrial",
	// },

	// "kprate" / "Kaleena Prate" //added on Jun 30, 2025. see database "teachers" collection

	// tepstein / Tamarin Epstein //added on Jul 2, 2025


	// https://console.firebase.google.com/u/0/project/qwoach/firestore/databases/-default-/data/~2Fteachers






}
